import designTokens from '@sohohouse/design-system/dist/tokens/tokens.common'

const sources = [
  {
    media: '--mobile-sm',
    width: designTokens.mediaQueryMobileSm.replace(/\D/g, '')
  },
  {
    media: '--mobile',
    width: designTokens.mediaQueryMobile.replace(/\D/g, '')
  },
  {
    media: '--tablet',
    width: designTokens.mediaQueryTablet.replace(/\D/g, '')
  },
  {
    media: '--desktop',
    width: designTokens.mediaQueryDesktop.replace(/\D/g, '')
  },
  {
    media: '--wide',
    width: designTokens.mediaQueryWide.replace(/\D/g, '')
  }
]

// Add DPR 2.0 capability for each screen size
export default sources.reduce((sourcesWithDpr, source) => {
  const dpr2 = Number(source.width) * 2
  return [
    ...sourcesWithDpr,
    source,
    {
      media: source.media,
      width: dpr2
    }
  ]
}, [])
